<template>
	<div class="tc-header-list">
		<v-container class="primary tc-header-list-layout ma-0 pa-0">
			<v-tabs 
				v-model="display_list_type"
				color="primary"
				dark
				slider-color="white"
				height="60px"
				v-on:change="onChangeDisplayListType">
					<v-tab
						:value="type.MEMBER"
						class="tc-header-list-tab"
						active-class="tc-header-list-tab-active v-tabs__item--active">
							メンバー
					</v-tab>
					<v-tab
						:value="type.PROJECT"
						class="tc-header-list-tab"
						active-class="tc-header-list-tab-active v-tabs__item--active">
							案件
					</v-tab>
			</v-tabs>
			<v-layout row justify-center>
				<v-flex xs3 class="d-flex">
					<v-btn flat color="white" small class="pa-0 mt-1 tc-header-list-icon-btn"
						v-on:click="showRightPaneMemberList">
						<v-icon >people</v-icon>
					</v-btn>
				</v-flex>
				<v-flex xs3 class="d-flex">
					<v-btn flat color="white" small class="pa-0 mt-1 tc-header-list-icon-btn"
						v-on:click="showRightPaneProjectList">
						<v-icon >assignment</v-icon>
					</v-btn>
				</v-flex>
				<v-flex xs6 class="d-flex">
					<v-btn v-if="!isAllExpanded" flat class="primary white--text tc-header-list-btn" @click="onClickFolding">全て閉じる</v-btn>
					<v-btn v-else flat class="primary white--text tc-header-list-btn" @click="onClickExpanding">全て開く</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>

import { DISPLAY_LIST_TYPE, LIST_MODE } from '../../classes/Const';

export default {
	name: 'TCHeaderList',
	props: [
	],
	data () {
		return {
			display_list_type: this.$store.getters['chart/displayListType'],
			type: DISPLAY_LIST_TYPE,
		}
	},
	methods: {
		onChangeDisplayListType: function() {
			if (this.display_list_type === DISPLAY_LIST_TYPE.MEMBER){
				this.$store.dispatch('chart/setDisplayListTypeMember');
				this.$store.dispatch('chart/setToggleAllExpandMember');
			}else{
				this.$store.dispatch('chart/setDisplayListTypeProject');
				this.$store.dispatch('chart/setToggleAllExpandProject');
			}
		},
		onClickFolding: function() {
			if (this.display_list_type === DISPLAY_LIST_TYPE.MEMBER){
				this.$store.dispatch('chart/foldingListMemberAll');
				this.$store.dispatch('chart/setToggleAllExpandMember');
			}else{
				this.$store.dispatch('chart/foldingListProjectAll');
				this.$store.dispatch('chart/setToggleAllExpandProject');
			}
		},
		onClickExpanding: function() {
			if (this.display_list_type === DISPLAY_LIST_TYPE.MEMBER){
				this.$store.dispatch('chart/expandingListMemberAll');
				this.$store.dispatch('chart/setToggleAllExpandMember');
			}else{
				this.$store.dispatch('chart/expandingListProjectAll');
				this.$store.dispatch('chart/setToggleAllExpandProject');
			}
		},
		showRightPaneMemberList:function(){
			this.$emit("show-rightpane-memberlist", {
				mode: LIST_MODE.REFERENCE,
			});
		},
		showRightPaneProjectList:function(){
			this.$emit("show-rightpane-projectlist", {
				mode: LIST_MODE.REFERENCE,
			});
		},
	},
	computed: {
		isAllExpanded() {
			return this.$store.getters['chart/isAllExpanded'];
		},
		displayListType: function() {
			return this.$store.getters['chart/displayListType'];
		},
	},
	watch: {
		displayListType: function(value) {
			this.display_list_type = value;
		},
	},
};
</script>
<style>
	.tc-header-list {
		flex: 0 0 300px !important;
		position: relative;
		border-right:solid 1px white;
		width: 300px;
		height: 96px;
	}
	.tc-header-list-layout {
		position: relative;
		height: 100%;
	}
	.tc-header-list-tab {
		width: 50%;
	}
	.tc-header-list-tab-active{
		box-shadow: none !important;
		pointer-events: none;
		cursor: default;
	}
	.tc-header-list-icon-btn {
		min-width: 30px;
		height: 25px !important;
	}
	.tc-header-list-btn {
		font-size: 12px;
		min-width: 91px;
		height: 25px !important;
		margin: 3px 1px;
	}
</style>


